import React, { Component } from 'react';
import jquery from 'jquery';
import {ciIcon} from '../helpers/helpers.js';

export class BranchSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branch: props.branch,
      repo_id: props.repo_id,
      project: props.project
    };
  }

  queryBuildInformation() {
    const url = 'https://api.bob-bench.org/v1/run/' + this.state.branch.last_id;
    jquery.getJSON(url)
      .done(function(data) {
        this.setState({run: data});
      }.bind(this));
  }

  componentDidMount() {
    this.queryBuildInformation();
  }

  toggleVisibility(ev) {
    /* don't expand if a link had been clicked */
    if (ev.target.nodeName === "A")
      return;

    var result = ev.target.closest("h4");
    var details = result.nextSibling;
    var i = result.querySelector("i");

    if (details.classList.contains("hidden")) {
      details.classList.remove("hidden");
      i.classList.remove("fa-plus");
      i.classList.add("fa-minus");
    } else {
      details.classList.add("hidden")
      i.classList.remove("fa-minus");
      i.classList.add("fa-plus");
    }
  }

  render() {
    var runInformation;
    if (this.state.run != null) {
      runInformation = [
        <tr key="tests"><td>Tests / Errors / Failures</td><td>{this.state.run.testCount} / {this.state.run.errorCount} / {this.state.run.failureCount}</td></tr>,
      ];
    }
    return (
      <div className="row">
        <div className="col-md-12 table-responsive">
        <h4 onClick={this.toggleVisibility} className="b-expandable">
          <i className="fa fa-fw fa-plus b-expandable"></i>
          Branch <b>{this.state.branch.branch}</b> build #{this.state.branch.build_number} on {ciIcon(this.state.project, this.state.branch.ci_system)} (
            <a href={window.location.pathname + "/" +
                        this.state.branch.branch +
                        "?ci=" + this.state.branch.ci_system + "&subNumber=" + this.state.branch.sub_number}>
              test details
            </a>)
        </h4>
        <table className="table hidden">
         <colgroup>
            <col className="col-md-4" />
            <col className="col-md-8" />
         </colgroup>
         <tbody>
          <tr><td>OS</td><td>{this.state.branch.os_name}</td></tr>
          <tr><td>CI</td><td>{this.state.branch.ci_system}</td></tr>
          <tr><td>Badge</td><td><img alt="Badge with number of tests" src={"https://api.bob-bench.org/v1/badge/" + this.state.repo_id + "?branch=" + this.state.branch.branch + "&ci=" + this.state.branch.ci_system + "&subNumber=" + this.state.branch.sub_number}/></td></tr>
          {runInformation}
        </tbody></table>
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/BranchSummary.js